var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_774_4475)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 32.5,
    r: 27.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 32.5,
    r: 27,
    stroke: "#16C098",
    strokeOpacity: 0.12
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8537 17.7695L37.1008 26.2152C37.3749 27.2459 37.5121 27.7612 37.7827 28.1824C38.0221 28.5552 38.3362 28.873 38.7046 29.1154C39.1208 29.3892 39.63 29.528 40.6484 29.8054L48.9941 32.0794L40.6484 34.3534C39.63 34.6309 39.1208 34.7697 38.7046 35.0435C38.3362 35.2858 38.0221 35.6036 37.7827 35.9765C37.5121 36.3977 37.3749 36.913 37.1008 37.9436L34.8537 46.3893L32.6067 37.9436C32.3325 36.913 32.1953 36.3977 31.9248 35.9765C31.6853 35.6036 31.3713 35.2858 31.0029 35.0435C30.5866 34.7697 30.0774 34.6309 29.059 34.3534L20.7134 32.0794L29.059 29.8054C30.0774 29.528 30.5866 29.3892 31.0029 29.1154C31.3713 28.873 31.6853 28.5552 31.9248 28.1824C32.1953 27.7612 32.3325 27.2459 32.6067 26.2152L34.8537 17.7695Z",
    fill: "#14725C",
    stroke: "#14725C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_774_4475",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0896531 0 0 0 0 0.0821254 0 0 0 0 0.458511 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_774_4475"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_774_4475",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGroup);
export default __webpack_public_path__ + "static/media/starGroup.915549b13b125aea10822514257bc7ba.svg";
export { ForwardRef as ReactComponent };